import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Nav from "@/components/Nav";
import { api, formatApiErrorDetail } from "@/lib/api";
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function CheckStatus() {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/participants/lookup", { email, phone });
      nav(`/dashboard?email=${encodeURIComponent(email)}&phone=${encodeURIComponent(phone)}`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Data tidak ditemukan");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen">
      <Nav />
      <div className="max-w-lg mx-auto px-4 md:px-8 py-16">
        <div className="text-[10px] tracking-[0.3em] text-[#FF3B30] font-display">MY DASHBOARD</div>
        <h1 className="font-display text-5xl mt-3">CHECK STATUS</h1>
        <p className="mt-2 text-white/60 text-sm">Masukkan email + nomor HP yang kamu daftarkan.</p>
        <form onSubmit={submit} className="mt-10 space-y-4" data-testid="check-form">
          <label className="block">
            <div className="text-[10px] tracking-widest text-white/60 uppercase font-display mb-2">Email</div>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="tactical-input" placeholder="you@email.com" data-testid="check-email" />
          </label>
          <label className="block">
            <div className="text-[10px] tracking-widest text-white/60 uppercase font-display mb-2">Phone</div>
            <input required type="tel" inputMode="numeric" autoComplete="tel" value={phone} onChange={(e) => setPhone(e.target.value)} className="tactical-input" placeholder="0812xxxxxxxx" data-testid="check-phone" />
          </label>
          <button type="submit" disabled={loading} className="btn-blaze w-full inline-flex items-center justify-center gap-2" data-testid="check-submit">
            {loading ? "SEARCHING..." : (<>OPEN DASHBOARD <MagnifyingGlass size={18} /></>)}
          </button>
        </form>
      </div>
    </div>
  );
}
